module.exports = __webpack_public_path__ + "files/0c8e414670d87ee852a0a6495b83de0b.png";